import type { RoleReqsRecommendedQuestion } from './generated/graphql';
import type {
  AnswerType,
  QuestionDescription,
  QuestionSource,
  SelectionType,
  SelectionTypeView,
} from './type';

type AnswerTypeGraphQL = RoleReqsRecommendedQuestion['answerType'];
type DescriptionGraphQL = RoleReqsRecommendedQuestion['description'];
type SelectionTypeGraphQL = RoleReqsRecommendedQuestion['selectionType'];
type SelectionTypeViewGraphQL =
  RoleReqsRecommendedQuestion['selectionTypeView'];
type QuestionSourceGraphQL = RoleReqsRecommendedQuestion['source'];

export const mapAnswerType = (answerType: AnswerTypeGraphQL): AnswerType => {
  const typeMapping: Record<AnswerTypeGraphQL, AnswerType> = {
    MULTI_SELECT: 'MultiSelect',
    SINGLE_SELECT: 'SingleSelect',
    FREE_TEXT: 'FreeText',
    URL_SINGLE_SELECT: 'UrlSingleSelect',
  };

  return typeMapping[answerType];
};

export const mapDescription = (
  description: DescriptionGraphQL,
): QuestionDescription => {
  const typeMapping: Record<DescriptionGraphQL, QuestionDescription> = {
    SINGLE_SELECT_ANY: 'SingleSelectAny',
    SINGLE_SELECT_ONLY: 'SingleSelectOnly',
    MULTI_SELECT: 'MultiSelect',
    RANGE_AT_LEAST: 'RangeAtLeast',
    RANGE_UP_TO: 'RangeUpTo',
    RANGE: 'Range',
    FREE_TEXT: 'FreeText',
  };
  return typeMapping[description];
};

export const mapSelectionType = (
  selectionType: SelectionTypeGraphQL,
): SelectionType => {
  const typeMapping: Record<SelectionTypeGraphQL, SelectionType> = {
    RADIO: 'Radio',
    CHECKBOX: 'Checkbox',
    RANGE: 'Range',
    FREE_TEXT: 'FreeText',
  };
  return typeMapping[selectionType];
};

export const mapSelectionTypeView = (
  selectionTypeView: SelectionTypeViewGraphQL,
): SelectionTypeView => {
  const typeMapping: Record<SelectionTypeViewGraphQL, SelectionTypeView> = {
    ANSWERS: 'Answers',
    SIMPLIFIED_ANSWERS: 'SimplifiedAnswers',
  };
  return typeMapping[selectionTypeView];
};

export const mapSource = (source: QuestionSourceGraphQL): QuestionSource => {
  const typeMapping: Record<QuestionSourceGraphQL, QuestionSource> = {
    LIBRARY: 'Library',
    CUSTOM: 'Custom',
  };
  return typeMapping[source];
};
